module.exports = __webpack_public_path__ + "static/media/I_goodnest_ux.36716d88.png";